export default "__VITE_ASSET__d625c19b__"